module.exports = __webpack_public_path__ + "img/essential.1b88ab61.svg";